import { verify } from './VerifyTOTP.commands';

export const mapStateToProps = () => {
    return {};
};

export const mapDispatchToProps = { verify };
